// extracted by mini-css-extract-plugin
module.exports = {"container":"_3htqcC","link":"_2Px2Ea","icon":"_2NtnOT","text":"_2E1rq8"};